export default __webpack_public_path__ + "static/EBH_HELLES_0-18031be904bfa4c8149f90cada9d737c.png";